<template>
    <!-- 可视化数字工厂 -->
    <div id="tab3">
        <div class="white-bg">
            <div class="page-width main-content">
                <!-- 产品介绍 -->
                <div>
                    <div class="sub-title">
                        <p>可视化数字工厂</p>
                    </div>
                    <div class="intro">
                        可视化数字工厂通过对工厂园区的大楼、生产车间、设备、管道、门禁等进行3D建模，实现物理工厂园区到3D虚拟工厂园区的数字化、可视化的转化。使工厂生产更为流畅，减少不必要的失误，有效节约生产成本。并能提高操作者的熟练度，使工作效率大幅度提高，避免意外人身伤害发生。
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/ksh/ksh2.png"
                        alt="系统架构"
                        class="app-img"
                    />
                </div>
                <!-- 系统版本 -->
                <div>
                    <div class="sub-title">
                        <p>系统版本</p>
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/ksh/ksh11.png"
                        alt="系统架构"
                        class="app-img"
                    />
                </div>
                <div class="sub-title">
                    <p>系统功能</p>
                </div>
            </div>
        </div>

        <div class="grey-bg">
            <div class="page-width main-content">
                <!-- 系统功能 -->
                <div class="system-function ksh-function">
                    <div class="flex card-page flex-wrap">
                        <div class="card-text">
                            <p class="p1">3D可视化</p>
                            <p class="p2">
                                通过搭建虚拟工业园区和工厂车间环境，实现工业园区内的建筑群、道路、设备、管线等空间对象的数字化和可视化，支持场景交互和全景漫游。
                            </p>
                        </div>
                        <div class="video-area">
                            <!-- <my-video
                                :videoSrc="
                                    require('../../../../../assets/video/ksh1.mp4')
                                "
                                :postSrc="
                                    require('../../../../../assets/video/post1.png')
                                "
                            ></my-video> -->
                        </div>
                    </div>
                    <div class="flex card-page flex-wrap flex-end">
                        <div class="video-area">
                            <!-- <my-video
                                :videoSrc="
                                    require('../../../../../assets/video/ksh2.mp4')
                                "
                                :postSrc="
                                    require('../../../../../assets/video/post2.png')
                                "
                            ></my-video> -->
                        </div>
                        <div class="card-text">
                            <p class="p1">可视化运行监测（数字孪生）</p>
                            <p class="p2">
                                从传统被动式管理模式转化为全自动、全区域、全天候、全目标的覆盖主动式安全管理模式，同时与视频、周边报警等安防系统实现无缝联动，以三维可视化形式向用户进行立体式展现。
                            </p>
                        </div>
                    </div>
                    <div class="flex card-page flex-wrap">
                        <div class="card-text">
                            <p class="p1">报警管理</p>
                            <p class="p2">
                                当设备发生报警时，自动定位到设备所在空间位置。建立故障信息库，设置故障信息识别规则及原因分析规则，当发生故障报警时，可第一时间提供分析与指导。当设备发生报警时，可联动设备关联的监控视频进行对比分析故障情况。保留报警历史记录，并进行常用设备及常见报警情况分析。
                            </p>
                        </div>
                        <img
                            src="../../../../../assets/img/softProduct/ksh/ksh12.png"
                            alt=""
                            class="app-img"
                        />
                    </div>
                    <div class="flex card-page flex-wrap flex-end">
                        <img
                            src="../../../../../assets/img/softProduct/ksh/ksh13.png"
                            alt=""
                            class="app-img"
                        />
                        <div class="card-text">
                            <p class="p1">安全管理</p>
                            <p class="p2">
                                视频监控系统可实现从大楼、楼层、单个监控设备监控设备纵向可视化管理，实时视频预览，监控设备精确定位及设备掉线及事件提醒等功能。门禁系统可实现门禁分布与状态监测，人员进出流程模拟等功能。
                            </p>
                        </div>
                    </div>
                    <div class="flex card-page flex-wrap">
                        <div class="card-text">
                            <p class="p1">资产管理</p>
                            <p class="p2">
                                建立设备资产清单台账，掌握资产情况，形成设备分类管理的信息档案，方便检索查阅设备相关资料。每个设备对应一个二维码，
                                扫码可查询设备信息档案。关联设备相关的文档资料（包含图纸、照片、文档、视频等文件），支持文档资料的上传、预览、下载等功能。集成设备运行数据、保留历史运行记录，积累数据，分析运行趋势及规律。实现从设备规划、选型、安装，到使用、维护、巡检、保养、维修、备品备件的全生命周期管理。
                            </p>
                        </div>
                        <img
                            src="../../../../../assets/img/softProduct/ksh/ksh14.png"
                            alt=""
                            class="app-img"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="white-bg">
            <div class="page-width main-content">
                <!-- 系统特点 -->
                <div>
                    <div class="sub-title">
                        <p>系统特点</p>
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/ksh/ksh1.png"
                        alt="系统特点"
                        class="app-img"
                    />
                </div>
                <!-- 产品优势 -->
                <div>
                    <div class="sub-title">
                        <p>产品优势</p>
                    </div>
                    <table class="table vswrap-table table-responsive">
                        <tr>
                            <th>序号</th>
                            <th>其他同类竞品</th>
                            <th>我们的产品</th>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>大多以二维效果为主，三维可视化程度较低</td>
                            <td>三维真实环境布局虚拟再现</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>缺少数字化模型支持，可视化与应用分离</td>
                            <td>
                                建立全方位的数字化模型，将可视化与应用功能融合
                            </td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>产品功能与实际使用没有可靠的数据连接</td>
                            <td>完善的自动化系统支持，实时监控设备运行数据</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>单一的系统管理</td>
                            <td>
                                多维应用系统集成，多元数据聚合的数字化协同管理
                            </td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td>以桌面应用或B/S管理系统为主</td>
                            <td>
                                方便快捷的移动端支持，管理平台与移动端协同服务
                            </td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td>系统开放性较低</td>
                            <td>
                                提供标准的Resful API接口，支持多样的接口对接方式
                            </td>
                        </tr>
                        <tr>
                            <td>7</td>
                            <td>缺少支持决策的数据分析</td>
                            <td>
                                利用数据分析技术，提供完整的数据分析与报表支持
                            </td>
                        </tr>
                    </table>
                </div>
                <!-- 解决问题 -->
                <div>
                    <div class="sub-title">
                        <p>解决问题</p>
                    </div>
                    <div class="row resolve-problem">
                        <div class="col-sm-6 col-xs-12">
                            <div class="index-feature">
                                <div class="index-feature-left reveal">
                                    <img
                                        class="index-feature-icon"
                                        src="../../../../../assets/img/softProduct/ksh/溯源.png"
                                    />
                                </div>
                                <div class="index-feature-right reveal">
                                    <h3 class="reveal">透明化生产设备</h3>
                                    <p
                                        class="reveal-later"
                                        data-sr-id="17"
                                        style="
                                            visibility: visible;
                                            opacity: 1;
                                            transition: opacity 0.6s
                                                cubic-bezier(0.5, 0, 0, 1) 0.6s;
                                        "
                                    >
                                        设备资源统一管理，保留所有设备的全生命周期档案，并提供数据备份。帮助用户快速、准确找到需要的信息，全程可追溯。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-xs-12">
                            <div class="index-feature">
                                <div class="index-feature-left reveal">
                                    <img
                                        class="index-feature-icon"
                                        src="../../../../../assets/img/softProduct/ksh/精确准确.png"
                                    />
                                </div>
                                <div class="index-feature-right">
                                    <h3 class="reveal">准确传递生产信息</h3>
                                    <p class="reveal-later">
                                        SCADA系统有效集成建筑、设备设施、安防系统、工艺系统、自控系统等的信息，将各个独立的系统连接为完整有效整体。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-xs-12">
                            <div class="index-feature">
                                <div class="index-feature-left reveal">
                                    <img
                                        class="index-feature-icon"
                                        src="../../../../../assets/img/softProduct/ksh/查验.png"
                                    />
                                </div>
                                <div class="index-feature-right">
                                    <h3 class="reveal">设备预防性维护</h3>
                                    <p class="reveal-later">
                                        实时采集设备运行信息，出现故障及时报警，维护人员根据报警信息进行异常检查。同时，维保人员根据维保计划定期进行设备维保，确保设备正常运转。
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6 col-xs-12">
                            <div class="index-feature">
                                <div class="index-feature-left reveal">
                                    <img
                                        class="index-feature-icon"
                                        src="../../../../../assets/img/softProduct/ksh/监管风控.png"
                                    />
                                </div>
                                <div class="index-feature-right">
                                    <h3 class="reveal">消除潜在的安全隐患</h3>
                                    <p class="reveal-later">
                                        设置缓冲区域，利用门禁系统、视频监控系统严格管控人员进、出。借助虚拟工厂帮助员工迅速掌握工作技能，避免生产事故发生。
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="img-bottom"></div>
            </div>
        </div>
    </div>
</template>

<script>
import myVideo from './myVideo.vue'
export default {
    components: {
        myVideo,
    },
}
</script>

<style scoped lang="less">
@import './softProduct.less';
.video-area {
    width: 55.65%;
    height: 360px;
}
.card-text {
    width: 44.35%;
}
</style>
